export const schools = [
    {
        value: "Nil",
        label: "Nil"
    },
    {
    value: "abdu gusau polytechnic, talata-mafara",
    label: "Abdu Gusau Polytechnic, Talata-Mafara"
},{
    value: "abia state college of education (technical), arochukwu",
    label: "Abia State College of Education (Technical), Arochukwu"
},{
    value: "abia state polytechnic, aba",
    label: "Abia State Polytechnic, Aba"
},{
    value: "abia state university, uturu",
    label: "Abia State University, Uturu"
},{
    value: "abubakar tafawa balewa university, bauchi",
    label: "Abubakar Tafawa Balewa University, Bauchi"
},{
    value: "abubakar tatari ali polytechnic, bauchi",
    label: "Abubakar Tatari Ali Polytechnic, Bauchi"
},{
    value: "achievers university, owo",
    label: "Achievers University, Owo"
},{
    value: "adamawa state polytechnic, yola",
    label: "Adamawa State Polytechnic, Yola"
},{
    value: "adamawa state university mubi",
    label: "Adamawa State University Mubi"
},{
    value: "adamu augie college of education, argungu",
    label: "Adamu Augie College of Education, Argungu"
},{
    value: "adekunle ajasin university, akungba",
    label: "Adekunle Ajasin University, Akungba"
},{
    value: "adeleke university, ede",
    label: "Adeleke University, Ede"
},{
    value: "adeniran ogunsanya college of education, otto/ijanikin",
    label: "Adeniran Ogunsanya College of Education, Otto/Ijanikin"
},{
    value: "adeyemi college of education, ondo",
    label: "Adeyemi College of Education, Ondo"
},{
    value: "afe babalola university, ado-ekiti",
    label: "Afe Babalola University, Ado-Ekiti"
},{
    value: "african thinkers community of inquiry college of education, enugu",
    label: "African Thinkers Community of inquiry College of Education, Enugu"
},{
    value: "african university of science & technology, abuja",
    label: "African University of Science & Technology, Abuja"
},{
    value: "ahmadu bello university, zaria",
    label: "Ahmadu Bello University, Zaria"
},{
    value: "air force institute of technology nigerian air force, kaduna",
    label: "Air Force Institute of Technology Nigerian Air Force, Kaduna"
},{
    value: "ajayi crowther university, ibadan",
    label: "Ajayi Crowther University, Ibadan"
},{
    value: "akanu ibiam federal polytechnic, unwana-afikpo",
    label: "Akanu Ibiam Federal Polytechnic, Unwana-Afikpo"
},{
    value: "akwa ibom state university of technology, uyo",
    label: "Akwa Ibom State University of Technology, Uyo"
},{
    value: "akwa-ibom state college of art and science, numkum",
    label: "Akwa-Ibom State College of Art and Science, Numkum"
},{
    value: "akwa-ibom state college of education, afaha-nsit",
    label: "Akwa-Ibom State College of Education, Afaha-Nsit"
},{
    value: "akwa-ibom state polytechnic, ikot-osurua",
    label: "Akwa-Ibom State Polytechnic, Ikot-Osurua"
},{
    value: "al-hikmah university, ilorin",
    label: "Al-Hikmah University, Ilorin"
},{
    value: "al-qalam university, katsina",
    label: "Al-Qalam University, Katsina"
},{
    value: "all states college of education, ero community junction akure",
    label: "All states College of Education, Ero Community Junction Akure"
},{
    value: "allover central polytechnic, sango-ota",
    label: "Allover Central Polytechnic, Sango-Ota"
},{
    value: "alvan ikoku college of education, owerri",
    label: "Alvan Ikoku College of Education, Owerri"
},{
    value: "ambrose alli university, ekpoma",
    label: "Ambrose Alli University, Ekpoma"
},{
    value: "american university of nigeria, yola",
    label: "American University of Nigeria, Yola"
},{
    value: "angel crown college of education, gidan-daya",
    label: "Angel Crown College of Education, Gidan-Daya"
},{
    value: "ansar-ud-deen college of education, oshodi",
    label: "Ansar-Ud-Deen College of Education, Oshodi"
},{
    value: "apa college of education, aido godo-okpoga",
    label: "Apa College of Education, Aido Godo-Okpoga"
},{
    value: "assanusiyah college of education, odeomu",
    label: "Assanusiyah College of Education, Odeomu"
},{
    value: "auchi polytechnic, auchi",
    label: "Auchi Polytechnic, Auchi"
},{
    value: "augustine university",
    label: "Augustine University"
},{
    value: "awori district college of education, bankole estate ijako-ota",
    label: "Awori District College of Education, Bankole Estate Ijako-Ota"
},{
    value: "babcock university,ilishan-remo",
    label: "Babcock University,Ilishan-Remo"
},{
    value: "bauchi institute for arabic and islamic studies, bauchi",
    label: "Bauchi Institute for Arabic and Islamic Studies, Bauchi"
},{
    value: "bauchi state university, gadau",
    label: "Bauchi State University, Gadau"
},{
    value: "bayelsa state college of education, okpoama-brass",
    label: "Bayelsa State College of Education, Okpoama-Brass"
},{
    value: "bayero university, kano",
    label: "Bayero University, Kano"
},{
    value: "baze university",
    label: "Baze University"
},{
    value: "bells university of technology, ota",
    label: "Bells University of Technology, Ota"
},{
    value: "benson idahosa university, benin city",
    label: "Benson Idahosa University, Benin City"
},{
    value: "benue state polytechnic, ugbokolo",
    label: "Benue State Polytechnic, Ugbokolo"
},{
    value: "benue state university, makurdi",
    label: "Benue State University, Makurdi"
},{
    value: "best legacy college of education, ogbomoso",
    label: "Best Legacy College of Education, Ogbomoso"
},{
    value: "bingham university, new karu",
    label: "Bingham University, New Karu"
},{
    value: "bowen university, iwo",
    label: "Bowen University, Iwo"
},{
    value: "bukar abba ibrahim university, damaturu",
    label: "Bukar Abba Ibrahim University, Damaturu"
},{
    value: "caleb university, lagos",
    label: "Caleb University, Lagos"
},{
    value: "calvin foundation college of education, naka",
    label: "Calvin Foundation College of Education, Naka"
},{
    value: "caritas university, enugu",
    label: "Caritas University, Enugu"
},{
    value: "cetep city university, lagos",
    label: "CETEP City University, Lagos"
},{
    value: "chrisland university",
    label: "Chrisland University"
},{
    value: "christopher university, mowe",
    label: "Christopher University, Mowe"
},{
    value: "chukwuemeka odumegwu ojukwu university, uli",
    label: "Chukwuemeka Odumegwu Ojukwu University, Uli"
},{
    value: "city college of education, maraba gurku",
    label: "City College of Education, Maraba Gurku"
},{
    value: "college of administrative and business studies, potiskum",
    label: "College of Administrative and Business Studies, Potiskum"
},{
    value: "college of education, (tech), lafiagi",
    label: "College of Education, (Tech), Lafiagi"
},{
    value: "college of education, agbor",
    label: "College of Education, Agbor"
},{
    value: "college of education, akwanga",
    label: "College of Education, Akwanga"
},{
    value: "college of education, ankpa",
    label: "College of Education, Ankpa"
},{
    value: "college of education, azare",
    label: "College of Education, Azare"
},{
    value: "college of education, ekiadolor",
    label: "College of Education, Ekiadolor"
},{
    value: "college of education, foreign links campus moro, ife, north",
    label: "College of Education, Foreign Links Campus Moro, Ife, North"
},{
    value: "college of education, gidan-waya",
    label: "College of Education, Gidan-Waya"
},{
    value: "college of education, gindiri",
    label: "College of Education, Gindiri"
},{
    value: "college of education, hong",
    label: "College of Education, Hong"
},{
    value: "college of education, ikere",
    label: "College of Education, Ikere"
},{
    value: "college of education, ilesha",
    label: "College of Education, Ilesha"
},{
    value: "college of education, ilorin",
    label: "College of Education, Ilorin"
},{
    value: "college of education, irra rd. ilemona",
    label: "College of Education, Irra Rd. Ilemona"
},{
    value: "college of education, jalingo",
    label: "College of Education, Jalingo"
},{
    value: "college of education, katsina-ala",
    label: "College of Education, Katsina-Ala"
},{
    value: "college of education, maru",
    label: "College of Education, Maru"
},{
    value: "college of education, minna",
    label: "College of Education, Minna"
},{
    value: "college of education, moro-ife",
    label: "College of Education, Moro-Ife"
},{
    value: "college of education, oju",
    label: "College of Education, Oju"
},{
    value: "college of education, oro",
    label: "College of Education, Oro"
},{
    value: "college of education, port harcourt",
    label: "College of Education, Port Harcourt"
},{
    value: "college of education, waka-biu",
    label: "College of Education, Waka-Biu"
},{
    value: "college of education, warri",
    label: "College of Education, Warri"
},{
    value: "cornerstone college of education, ikeja",
    label: "Cornerstone College of Education, Ikeja"
},{
    value: "covenant polytechnic, aba",
    label: "Covenant Polytechnic, Aba"
},{
    value: "covenant university, ota",
    label: "Covenant University, Ota"
},{
    value: "crawford university, igbesa",
    label: "Crawford University, Igbesa"
},{
    value: "crescent university",
    label: "Crescent University"
},{
    value: "cross river state university of science &technology, calabar",
    label: "Cross River State University of Science &Technology, Calabar"
},{
    value: "crown polytechnic, odo ado-ekiti",
    label: "Crown Polytechnic, Odo Ado-Ekiti"
},{
    value: "d.s. adegbenro ict polytechnics, abeokuta",
    label: "D.S. ADEGBENRO ICT Polytechnics, Abeokuta"
},{
    value: "delar college of education, egbeda",
    label: "Delar College of Education, Egbeda"
},{
    value: "delta state college of physical education, mosogar",
    label: "Delta State College of Physical Education, Mosogar"
},{
    value: "delta state polytechnic, ozoro",
    label: "Delta State Polytechnic, Ozoro"
},{
    value: "delta state polytechnic, tefe ogharra",
    label: "Delta State Polytechnic, tefe Ogharra"
},{
    value: "delta state polytechnic, ugwashi-uku",
    label: "Delta State Polytechnic, Ugwashi-Uku"
},{
    value: "delta state university abraka",
    label: "Delta State University Abraka"
},{
    value: "dorben polytechnic, bwari",
    label: "Dorben Polytechnic, Bwari"
},{
    value: "eastern palm university ogboko, imo state",
    label: "Eastern Palm University Ogboko, Imo State"
},{
    value: "ebonyi state college of education, ikwo",
    label: "Ebonyi State College of Education, Ikwo"
},{
    value: "ebonyi state university, abakaliki",
    label: "Ebonyi State University, Abakaliki"
},{
    value: "edo state institute of management and technology, usen",
    label: "Edo State Institute of Management and Technology, Usen"
},{
    value: "edo university, iyamo",
    label: "Edo University, Iyamo"
},{
    value: "edwin clark university, kaigbodo",
    label: "Edwin Clark University, Kaigbodo"
},{
    value: "ekiti state university",
    label: "Ekiti State University"
},{
    value: "elder oyama memorial college of education, obubra",
    label: "Elder Oyama Memorial College of Education, Obubra"
},{
    value: "elizade university, ilara-mokin",
    label: "Elizade University, Ilara-Mokin"
},{
    value: "emmanuel alyande college of education, oyo",
    label: "Emmanuel Alyande College of Education, Oyo"
},{
    value: "enugu polytechnic, Enugu",
    label: "Enugu Polytechnic, Enugu"
},{
    value: "enugu state college of education (tech.), enugu",
    label: "Enugu State College of Education (Tech.), Enugu"
},{
    value: "enugu state university of science and technology, enugu",
    label: "Enugu State University of Science and Technology, Enugu"
},{
    value: "evangel university, akaeze",
    label: "Evangel University, Akaeze"
},{
    value: "fct college of education",
    label: "FCT College of Education"
},{
    value: "fed college of education (technical), omoku",
    label: "Fed College of Education (Technical), Omoku"
},{
    value: "federal college of animal health and production technology, moor plantation",
    label: "Federal College of Animal Health and Production Technology, Moor Plantation"
},{
    value: "federal college of educ., abeokuta",
    label: "Federal College of Educ., Abeokuta"
},{
    value: "federal college of education",
    label: "Federal College of Education"
},{
    value: "federal college of education (special) oyo",
    label: "Federal College of Education (Special) Oyo"
},{
    value: "federal college of education (technical) (female only), gusau",
    label: "Federal College of Education (Technical) (Female Only), Gusau"
},{
    value: "federal college of education (technical), umunze",
    label: "Federal College of Education (Technical), Umunze"
},{
    value: "federal college of education (technical), akoka",
    label: "Federal College of Education (Technical), Akoka"
},{
    value: "federal college of education (technical), asaba",
    label: "Federal College of Education (Technical), Asaba"
},{
    value: "federal college of education (technical), bichi",
    label: "Federal College of Education (Technical), Bichi"
},{
    value: "federal college of education (technical), gombe",
    label: "Federal College of Education (Technical), Gombe"
},{
    value: "federal college of education (technical), potiskum",
    label: "Federal College of Education (Technical), Potiskum"
},{
    value: "federal college of education, kano",
    label: "Federal College of Education, Kano"
},{
    value: "federal college of education, kontagora",
    label: "Federal college of Education, Kontagora"
},{
    value: "federal college of education, obudu",
    label: "Federal College of Education, Obudu"
},{
    value: "federal college of education, okene",
    label: "Federal College of Education, Okene"
},{
    value: "federal college of education, pankshin",
    label: "Federal College of Education, Pankshin"
},{
    value: "federal college of education, yola",
    label: "Federal College of Education, Yola"
},{
    value: "federal college of education, zaria",
    label: "Federal College of Education, Zaria"
},{
    value: "federal polytechnic, bali",
    label: "Federal Polytechnic, Bali"
},{
    value: "federal polytechnic, bauchi",
    label: "Federal Polytechnic, Bauchi"
},{
    value: "federal polytechnic, bida",
    label: "Federal Polytechnic, Bida"
},{
    value: "federal polytechnic, damaturu",
    label: "Federal Polytechnic, Damaturu"
},{
    value: "federal polytechnic, ede",
    label: "Federal Polytechnic, Ede"
},{
    value: "federal polytechnic, ekiti",
    label: "Federal Polytechnic, Ekiti"
},{
    value: "federal polytechnic, ekowe",
    label: "Federal Polytechnic, Ekowe"
},{
    value: "federal polytechnic, idah",
    label: "Federal Polytechnic, Idah"
},{
    value: "federal polytechnic, ilaro",
    label: "Federal Polytechnic, Ilaro"
},{
    value: "federal polytechnic, ile-oluji",
    label: "Federal Polytechnic, Ile-Oluji"
},{
    value: "federal polytechnic, kaura namoda",
    label: "Federal Polytechnic, Kaura Namoda"
},{
    value: "federal polytechnic, mubi",
    label: "Federal Polytechnic, Mubi"
},{
    value: "federal polytechnic, namoda",
    label: "Federal Polytechnic, Namoda"
},{
    value: "federal polytechnic, nassarawa",
    label: "Federal Polytechnic, Nassarawa"
},{
    value: "federal polytechnic, nekede",
    label: "Federal Polytechnic, Nekede"
},{
    value: "federal polytechnic, offa",
    label: "Federal Polytechnic, Offa"
},{
    value: "federal polytechnic, oko",
    label: "Federal Polytechnic, Oko"
},{
    value: "federal school of dental technology and therapy, enugu",
    label: "Federal School of Dental Technology and Therapy, Enugu"
},{
    value: "federal university gashua, yobe",
    label: "Federal University Gashua, Yobe"
},{
    value: "federal university of agriculture, abeokuta",
    label: "Federal University of Agriculture, Abeokuta"
},{
    value: "federal university of petroleum resources, effurun",
    label: "Federal University of Petroleum Resources, Effurun"
},{
    value: "federal university of technology, akure",
    label: "Federal University of Technology, Akure"
},{
    value: "federal university of technology, minna",
    label: "Federal University of Technology, Minna"
},{
    value: "federal university of technology, owerri",
    label: "Federal University of Technology, Owerri"
},{
    value: "federal university, birnin kebbi",
    label: "Federal University, Birnin Kebbi"
},{
    value: "federal university, dutse",
    label: "Federal University, Dutse"
},{
    value: "federal university, dutsin-ma",
    label: "Federal University, Dutsin-Ma"
},{
    value: "federal university, gusau",
    label: "Federal University, Gusau"
},{
    value: "federal university, kashere",
    label: "Federal University, Kashere"
},{
    value: "federal university, lafia",
    label: "Federal University, Lafia"
},{
    value: "federal university, lokoja",
    label: "Federal University, Lokoja"
},{
    value: "federal university, ndifu-alike",
    label: "Federal University, Ndifu-Alike"
},{
    value: "federal university, otuoke",
    label: "Federal University, Otuoke"
},{
    value: "federal university, oye-ekiti",
    label: "Federal University, Oye-Ekiti"
},{
    value: "federal university, wukari",
    label: "Federal University, Wukari"
},{
    value: "fidei polytechnic, gboko",
    label: "Fidei Polytechnic, Gboko"
},{
    value: "fountain unveristy, oshogbo",
    label: "Fountain Unveristy, Oshogbo"
},{
    value: "gateway ict institute, itori",
    label: "Gateway ICT Institute, Itori"
},{
    value: "gateway ict polytechnic, igbesa",
    label: "Gateway ICT Polytechnic, Igbesa"
},{
    value: "gateway ict polytechnic, saapade",
    label: "Gateway ICT Polytechnic, Saapade"
},{
    value: "godfrey okoye university, ugwuomu-nike",
    label: "Godfrey Okoye University, Ugwuomu-Nike"
},{
    value: "gombe state univeristy, gombe",
    label: "Gombe State Univeristy, Gombe"
},{
    value: "grace polytechnic, surulere",
    label: "Grace Polytechnic, Surulere"
},{
    value: "gregory university, uturu",
    label: "Gregory University, Uturu"
},{
    value: "hallmark university",
    label: "Hallmark University"
},{
    value: "harvard wilson college of education, aba",
    label: "Harvard Wilson College of Education, Aba"
},{
    value: "hassan usman katsina polytechnic, katsina",
    label: "Hassan Usman Katsina Polytechnic, Katsina"
},{
    value: "heritage polytechnic, eket",
    label: "Heritage Polytechnic, Eket"
},{
    value: "hezekiah university, umudi",
    label: "Hezekiah University, Umudi"
},{
    value: "hill college of education, gwanji, akwanga",
    label: "Hill College of Education, Gwanji, Akwanga"
},{
    value: "hussaini adamu federal polytechnic, kazaure",
    label: "Hussaini Adamu Federal Polytechnic, Kazaure"
},{
    value: "ibadan city polytechnic, dugbe",
    label: "Ibadan City Polytechnic, Dugbe"
},{
    value: "ibrahim badamasi babangida university, lapai",
    label: "Ibrahim Badamasi Babangida University, Lapai"
},{
    value: "igbajo polytechnic, igbajo",
    label: "Igbajo Polytechnic, Igbajo"
},{
    value: "igbinedion university, okada",
    label: "Igbinedion University, Okada"
},{
    value: "ignatius ajuru university of education, rumuolumeni",
    label: "Ignatius Ajuru University of Education, Rumuolumeni"
},{
    value: "imo state polytechnic, umuagwo",
    label: "Imo State Polytechnic, Umuagwo"
},{
    value: "imo state university, owerri",
    label: "Imo State University, Owerri"
},{
    value: "institute of arabic and islamic studies, olodo ibadan",
    label: "Institute of Arabic and Islamic Studies, Olodo Ibadan"
},{
    value: "institute of ecumenical education, enugu",
    label: "Institute of Ecumenical Education, Enugu"
},{
    value: "institute of management. & technology, enugu",
    label: "Institute of Management. & Technology, Enugu"
},{
    value: "interlink polytechnic,  ijebu-jesa",
    label: "Interlink Polytechnic,  IJebu-Jesa"
},{
    value: "isa kaita college of education, dutsinma",
    label: "Isa Kaita College of Education, Dutsinma"
},{
    value: "jama’atu nasir islam college of education, kaduna",
    label: "Jama’Atu Nasir Islam College of Education, Kaduna"
},{
    value: "jibwis college of arabic and islamic education, gombe",
    label: "Jibwis College of Arabic and Islamic Education, Gombe"
},{
    value: "jigawa state college of education, gumel",
    label: "Jigawa State College of Education, Gumel"
},{
    value: "jigawa state polytechnic, dutse",
    label: "Jigawa State Polytechnic, Dutse"
},{
    value: "joseph ayo babalola university, ikeji-arakeji",
    label: "Joseph Ayo Babalola University, Ikeji-Arakeji"
},{
    value: "kaduna polytechnic, kaduna",
    label: "Kaduna Polytechnic, Kaduna"
},{
    value: "kaduna state university, kaduna",
    label: "Kaduna State University, Kaduna"
},{
    value: "kano state college of education, kumbotso zaria rd",
    label: "Kano State College of Education, Kumbotso Zaria Rd"
},{
    value: "kano state polytechnic, kano",
    label: "Kano State Polytechnic, Kano"
},{
    value: "kano university of science & technology, wudil",
    label: "Kano University of Science & Technology, Wudil"
},{
    value: "kashim-ibrahim college of educ., maiduguri",
    label: "Kashim-Ibrahim College of Educ., Maiduguri"
},{
    value: "kebbi state college of education, argungu",
    label: "Kebbi State College of Education, Argungu"
},{
    value: "kebbi state university, kebbi",
    label: "Kebbi State University, Kebbi"
},{
    value: "kings polytechnic, ubiaja",
    label: "Kings Polytechnic, Ubiaja"
},{
    value: "kings university",
    label: "Kings University"
},{
    value: "kinsey college of education, ilorin south",
    label: "Kinsey College Of Education, Ilorin South"
},{
    value: "kogi state polytechnic, lokoja",
    label: "Kogi State Polytechnic, Lokoja"
},{
    value: "kogi state university anyigba",
    label: "Kogi State University Anyigba"
},{
    value: "kwara state polytechnic, ilorin",
    label: "Kwara State Polytechnic, Ilorin"
},{
    value: "kwara state university, ilorin",
    label: "Kwara State University, Ilorin"
},{
    value: "kwararafa university, wukari",
    label: "Kwararafa University, Wukari"
},{
    value: "ladoke akintola university of technology, ogbomoso",
    label: "Ladoke Akintola University of Technology, Ogbomoso"
},{
    value: "lagos city polytechnic, ikeja",
    label: "Lagos City Polytechnic, Ikeja"
},{
    value: "lagos state polytechnic, ikorodu",
    label: "Lagos State Polytechnic, Ikorodu"
},{
    value: "lagos state university of science and technology, ikorodu",
    label: "Lagos State University of Science and Technology, Ikorodu"
},{
    value: "lagos state university, ojo",
    label: "Lagos State University, Ojo"
},{
    value: "landmark university, omu-aran.",
    label: "Landmark University, Omu-Aran."
},{
    value: "lead city university, ibadan",
    label: "Lead City University, Ibadan"
},{
    value: "lighthouse polytechnic, evbuobanosa",
    label: "Lighthouse Polytechnic, Evbuobanosa"
},{
    value: "madonna university, okija",
    label: "Madonna University, Okija"
},{
    value: "mcpherson university, seriki sotayo, ajebo",
    label: "Mcpherson University, Seriki Sotayo, Ajebo"
},{
    value: "michael okpara university of agricultural umudike",
    label: "Michael Okpara University of Agricultural Umudike"
},{
    value: "michael otedola college of primary education, moforiji",
    label: "Michael Otedola College of Primary Education, Moforiji"
},{
    value: "micheal & cecilia university",
    label: "Micheal & Cecilia University"
},{
    value: "modibbo adama university of technology, yola",
    label: "Modibbo Adama University of Technology, Yola"
},{
    value: "mohammed goni of legal and islamic studies, maiduguri",
    label: "Mohammed Goni of Legal and Islamic Studies, Maiduguri"
},{
    value: "moshood abiola polytechnic, abeokuta",
    label: "Moshood Abiola Polytechnic, Abeokuta"
},{
    value: "mountain top university",
    label: "Mountain Top University"
},{
    value: "mufutau’ lanihun college of education, oremeji",
    label: "Mufutau’ Lanihun College of Education, Oremeji"
},{
    value: "muhyideen college of education, ilorin",
    label: "Muhyideen College of Education, Ilorin"
},{
    value: "nacabs polytechnic, akwanga",
    label: "Nacabs Polytechnic, Akwanga"
},{
    value: "nana aishat memorial college of education, ilorin",
    label: "Nana Aishat Memorial College of Education, Ilorin"
},{
    value: "nasarawa state polytechnic, lafia",
    label: "Nasarawa State Polytechnic, Lafia"
},{
    value: "nasarawa state university, keffi",
    label: "Nasarawa State University, Keffi"
},{
    value: "national open university of nigeria, lagos",
    label: "National Open University of Nigeria, Lagos"
},{
    value: "niger delta university, yenagoa",
    label: "Niger Delta University, Yenagoa"
},{
    value: "niger state polytechnic, zungeru",
    label: "Niger State Polytechnic, Zungeru"
},{
    value: "nigeria army school of military engineering, makurdi",
    label: "Nigeria Army School of Military Engineering, Makurdi"
},{
    value: "nigeria police academy, wudil",
    label: "Nigeria Police Academy, Wudil"
},{
    value: "nigerian defence academy, kaduna",
    label: "Nigerian Defence Academy, Kaduna"
},{
    value: "nigerian institute of journalism, (nij), ogba estate, ikeja",
    label: "Nigerian Institute of Journalism, (NIJ), Ogba Estate, Ikeja"
},{
    value: "nigerian-turkish nile university, abuja",
    label: "Nigerian-Turkish Nile University, Abuja"
},{
    value: "nnamdi azikiwe university, awka",
    label: "Nnamdi Azikiwe University, Awka"
},{
    value: "nogak polytechnic, ikom",
    label: "Nogak Polytechnic, Ikom"
},{
    value: "northwest university, kano",
    label: "Northwest University, Kano"
},{
    value: "novena university, ogume",
    label: "Novena University, Ogume"
},{
    value: "nuhu bamalli polytechnic, zaria",
    label: "Nuhu Bamalli Polytechnic, Zaria"
},{
    value: "nwafor orizu college of education, nsugbe",
    label: "Nwafor Orizu College of Education, Nsugbe"
},{
    value: "obafemi awolowo university, ile-ife",
    label: "Obafemi Awolowo University, Ile-Ife"
},{
    value: "obong university, obong ntak",
    label: "Obong University, Obong Ntak"
},{
    value: "oduduwa university, ipetumodu - osun state",
    label: "Oduduwa University, Ipetumodu - Osun State"
},{
    value: "olabisi onabanjo university, ago iwoye",
    label: "Olabisi Onabanjo University, Ago Iwoye"
},{
    value: "ondo state university of medical sciences",
    label: "Ondo State University of Medical Sciences"
},{
    value: "ondo state university of science and technology, okitipupa",
    label: "Ondo State University of Science and Technology, Okitipupa"
},{
    value: "onit college of education, abagana",
    label: "ONIT College of Education, Abagana"
},{
    value: "osun state college of education, ila-orangun",
    label: "Osun State College of Education, Ila-Orangun"
},{
    value: "osun state college of technology, esa-oke",
    label: "Osun State College of Technology, Esa-Oke"
},{
    value: "osun state polytechnic, iree",
    label: "Osun State Polytechnic, Iree"
},{
    value: "osun state university, osogbo",
    label: "Osun State University, Osogbo"
},{
    value: "our saviour inst. of sci. & tech. college of education, enugu",
    label: "Our Saviour Inst. Of Sci. & Tech. College of Education, Enugu"
},{
    value: "our saviour institute of science agric and technology (osisatech), enugu",
    label: "Our Saviour Institute of Science Agric and Technology (OSISATECH), Enugu"
},{
    value: "oyo state college of education, oyo",
    label: "Oyo State College of Education, Oyo"
},{
    value: "oyo state technical university, ibadan",
    label: "Oyo State Technical University, Ibadan"
},{
    value: "pan-atlantic university, lagos",
    label: "Pan-Atlantic University, Lagos"
},{
    value: "paul university, awka",
    label: "Paul University, Awka"
},{
    value: "plateau state polytechnic, barkin ladi",
    label: "Plateau State Polytechnic, Barkin Ladi"
},{
    value: "plateau state university, bokkos",
    label: "Plateau State University, Bokkos"
},{
    value: "prime polytechnic, ajaokuta",
    label: "Prime Polytechnic, Ajaokuta"
},{
    value: "ramat polytechnic, maiduguri",
    label: "Ramat Polytechnic, Maiduguri"
},{
    value: "redeemer's university, mowe",
    label: "Redeemer's University, Mowe"
},{
    value: "renaissance university, enugu",
    label: "Renaissance University, Enugu"
},{
    value: "rhema university, obeama-asa",
    label: "Rhema University, Obeama-Asa"
},{
    value: "ritman university",
    label: "Ritman University"
},{
    value: "river state university of science and technology",
    label: "River State University of Science and Technology"
},{
    value: "rivers state college of arts and science, rumola",
    label: "Rivers State College of Arts and Science, Rumola"
},{
    value: "rivers state polytechnic, bori",
    label: "Rivers State Polytechnic, Bori"
},{
    value: "ronik polytechnic, ejigbo",
    label: "Ronik Polytechnic, Ejigbo"
},{
    value: "rufus giwa polytechnic, owo",
    label: "Rufus Giwa Polytechnic, Owo"
},{
    value: "salem university, lokoja",
    label: "Salem University, Lokoja"
},{
    value: "samuel adegboyega university, ogwa",
    label: "Samuel Adegboyega University, Ogwa"
},{
    value: "shaka polytechnic, benin city",
    label: "Shaka Polytechnic, Benin City"
},{
    value:'skyline university',
    label:'Skyline University'
},{
    value: "shehu shagari college of education, sokoto",
    label: "Shehu Shagari College of Education, Sokoto"
},{
    value: "sokoto state polytechnic, sokoto",
    label: "Sokoto State Polytechnic, Sokoto"
},{
    value: "southwestern university, oku owa",
    label: "Southwestern University, Oku Owa"
},{
    value: "st. augustine college of education (project time), yaba",
    label: "St. Augustine College of Education (Project Time), Yaba"
},{
    value: "sule lamido university, kafin hausa, jigawa",
    label: "Sule Lamido University, Kafin Hausa, Jigawa"
},{
    value: "tai solarin college of education, ijebu-ode",
    label: "Tai Solarin College of Education, Ijebu-Ode"
},{
    value: "tai solarin university of education, ijebu ode",
    label: "Tai Solarin University of Education, Ijebu Ode"
},{
    value: "tansian university, umunya",
    label: "Tansian University, Umunya"
},{
    value: "taraba state polytechnic, jalingo",
    label: "Taraba State Polytechnic, Jalingo"
},{
    value: "temple-gate polytechnic, aba",
    label: "Temple-Gate Polytechnic, Aba"
},{
    value: "the african church college of education, adewale adegun avenue",
    label: "The African Church College of Education, Adewale Adegun Avenue"
},{
    value: "the college of education, nsukka",
    label: "The College of Education, Nsukka"
},{
    value: "the polytechnic imesi-ile",
    label: "The Polytechnic Imesi-Ile"
},{
    value: "the polytechnic, ibadan",
    label: "The Polytechnic, Ibadan"
},{
    value: "the polytechnic, ile-ife",
    label: "The Polytechnic, Ile-Ife"
},{
    value: "topmost college of education, ipaja",
    label: "Topmost College of Education, Ipaja"
},{
    value: "tower polytechnic, ibadan",
    label: "Tower Polytechnic, Ibadan"
},{
    value: "umar suleiman college of education, gashua",
    label: "Umar Suleiman College of Education, Gashua"
},{
    value: "umar-ibn ei-kanemi college of education, dutsinma",
    label: "Umar-Ibn EI-Kanemi College of Education, Dutsinma"
},{
    value: "university of abuja, gwagwalada",
    label: "University of Abuja, Gwagwalada"
},{
    value: "university of agriculture, makurdi",
    label: "University of Agriculture, Makurdi"
},{
    value: "university of benin",
    label: "University of Benin"
},{
    value: "university of calabar",
    label: "University of Calabar"
},{
    value: "university of ibadan",
    label: "University of Ibadan"
},{
    value: "university of ilorin",
    label: "University of Ilorin"
},{
    value: "university of jos",
    label: "University of Jos"
},{
    value: "university of lagos",
    label: "University of Lagos"
},{
    value: "university of maiduguri",
    label: "University of Maiduguri"
},{
    value: "university of mkar, mkar",
    label: "University of Mkar, Mkar"
},{
    value: "university of nigeria, nsukka",
    label: "University of Nigeria, Nsukka"
},{
    value: "university of port-harcourt",
    label: "University of Port-Harcourt"
},{
    value: "university of uyo",
    label: "University of Uyo"
},{
    value: "usumanu danfodiyo university, sokoto",
    label: "Usumanu Danfodiyo University, Sokoto"
},{
    value: "veritas university",
    label: "Veritas University"
},{
    value: "waziri umaru federal polytechnic, birnin kebbi",
    label: "Waziri Umaru Federal Polytechnic, Birnin Kebbi"
},{
    value: "wellspring university, evbuobanosa",
    label: "Wellspring University, Evbuobanosa"
},{
    value: "western delta university, oghara",
    label: "Western Delta University, Oghara"
},{
    value: "wolex polytechnic, ikeja",
    label: "Wolex Polytechnic, Ikeja"
},{
    value: "yaba college of technology, yaba",
    label: "Yaba College of Technology, Yaba"
},{
    value: "yewa central college of education, adehun abeokuta",
    label: "Yewa Central College of Education, Adehun Abeokuta"
},{
    value: "yobe state polytechnic, geidam",
    label: "Yobe State Polytechnic, Geidam"
},{
    value: "yusuf bala usman college of legal and general studies, daura",
    label: "Yusuf Bala Usman College of Legal and General Studies, Daura"
}];